/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineSharedDisciplinesQueryResponse,
  GetApiV1ClassroomdisciplineSharedDisciplinesQueryParams,
  GetApiV1ClassroomdisciplineSharedDisciplines401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedDisciplines.ts";

function getGetApiV1ClassroomdisciplineSharedDisciplinesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/shared/disciplines` as const,
  };
  return res;
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de disciplinas ativas (nome resolvido por cultura) (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/disciplines}
 */
export async function getApiV1ClassroomdisciplineSharedDisciplines(
  params?: GetApiV1ClassroomdisciplineSharedDisciplinesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineSharedDisciplinesQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedDisciplines401>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineSharedDisciplinesUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
